const replaceUrl = newUrl => {
  let url = new URL(window.location.href);
  url.search = newUrl;
  history.replaceState(history.state, '', url.href);
}

export default replaceUrl;
